import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const CustomerAgreement = () => {
  return (
    <div>
      <Navbar />
      <section className="in_page p70 bg4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="hadding">Customer Agreement</h1>
              <p>This Customer Agreement (“Agreement”) governs your use of Dyntech’s platforms and services. By opening an account or using our offerings, you accept these terms.</p>
            </div>
            <div className="col-md-4 m-auto">
              <img
                src="/img/customer-agreement.png"
                alt="Customer Agreement"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
       <section className="in_page p70 bg2">
        <div className="container">
          <h4 className="mb-3"><b>1. Account Setup & Verification</b></h4>
         
          <ul className="list mb-4 mb-md-5">
            <li><b>  Eligibility:  </b> Must be 18+ and legally permitted to enter into contracts. </li> 
            <li><b>  KYC/AML Compliance:</b>   Submission of required documentation; approval subject to our review. </li> 
          </ul>
          

           <h4 className="mb-3"><b>2. Funding & Margin</b></h4>
         
          <ul className="list mb-4 mb-md-5">
            <li><b>   Deposits:</b>  Wire transfers, ACH, and select cryptocurrencies. </li> 
            <li><b> Margin Requirements: </b>   Vary by asset class; refer to our Margin Table </li> 
          </ul>

           <h4 className="mb-3"><b>3. Order Execution</b></h4>
         
          <ul className="list mb-4 mb-md-5">
            <li><b>Order Types:   </b> Market, limit, stop orders, and advanced algos. </li> 
            <li><b>  Best Execution:  </b> We route orders to top-tier liquidity venues; execution quality may vary by market conditions. </li> 
          </ul>



          <h4 className="mb-3"><b>4. Fees & Billing</b></h4>
          <ul className="list mb-4 mb-md-5">
            <li><b>  Trading Fees:  </b> Commission- or spread-based, as disclosed at signup. </li> 
            <li><b>  Service Fees: </b>  Monthly subscription or project fees for development and advisory. </li> 
          </ul>

            <h4 className="mb-3"><b>5. Risk & Liability</b></h4>
          <ul className="list mb-4 mb-md-5">
            <li><b>  No Warranties:  </b> Services provided “as is.” </li> 
            <li><b>  Limitation of Liability: </b> Dyntech’s liability capped at fees paid in the prior 12 months.</li> 
          </ul>

            <h4 className="mb-3"><b>6. Termination</b></h4>
          <ul className="list mb-4 mb-md-5">
            <li><b>  By You:  </b> Close your account via support portal; outstanding obligations remain due. </li> 
            <li><b>   By Dyntech: </b> For breach of this Agreement or suspicious activity, with notice where required by law. </li> 
          </ul>

            <h4 className="mb-3"><b>7. Governing Law & Dispute Resolution</b></h4>
          <ul className="list mb-4 mb-md-5">
            <li><b> Jurisdiction: </b>   State of New York, USA. </li> 
            <li><b>  Arbitration: </b>  Binding arbitration for disputes under $75,000; court litigation permitted for larger claims. </li> 
          </ul>
           
 
  </div>
      </section>
      <Footer />
    </div>
  );
};

export default CustomerAgreement;
